import React from "react";

export const RequestKidsInfoCheck: React.FC = () => {

    return (
        <>Autorizo que se pueda solicitar y dar información a los tutores del colegio de los niños a fin de coordinar y mejorar su atención y desarrollo.</>
    )

}